import { Button, ButtonsGroup, Grid, InputText } from "#/atoms";
import { FC, memo } from "react";

import { DESKTOP_SPACING } from "@/theme";
import { VirtualStagingFurnitureCardProps } from "./VirtualStagingFurniture.interface";

const VirtualStagingFurnitureFields: FC<VirtualStagingFurnitureCardProps> = ({
  externalUrl,
  furnitureNames,
  isAdmin,
  onAddFurnitures,
  onChangeUrl,
  orderServiceId
}) => {


  return (
    <Grid columnGap={DESKTOP_SPACING.XL} gridTemplateColumns="repeat(1, 100%)" margin="0">
        <a href="https://www.dropbox.com/s/najp3ibppvjswzy/Photoplan%20Virtual%20Staging%20Catalouge%20Standard%202023.pdf?dl=0" target="_blank" rel="noopener noreferrer">
            <img src="/virtualstaging_link.jpg" />
        </a>
        {isAdmin && 
            <InputText
                type="text"
                label="Chosen furniture names"
                value={externalUrl}
                onChange={(e) => onChangeUrl?.(e.target.value, orderServiceId)}
              />}
        {!isAdmin && furnitureNames && <><InputText
            type="text"
            label="Chosen furniture names"
            value={furnitureNames.value}
            onChange={furnitureNames.onChange}
          />
           <ButtonsGroup>
            <Button onClick={() => onAddFurnitures?.(orderServiceId)}>
                Save
            </Button>
          </ButtonsGroup></> }
        </Grid>
  );
};

export default memo(VirtualStagingFurnitureFields);